import { ColorUnion, TagColor } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

export function translateStatus(status: string): string {
  switch (status) {
    case 'pending':
      return i18n.t('integrations_primobox.statuses.pending')
    case 'ready':
      return i18n.t('integrations_primobox.statuses.ready')
    case 'failed':
      return i18n.t('integrations_primobox.statuses.failed')
    case 'deactivated':
      return i18n.t('integrations_primobox.statuses.deactivated')
    case 'uploaded':
      return i18n.t('integrations_primobox.statuses.uploaded')
    case 'delivered':
      return i18n.t('integrations_primobox.statuses.delivered')
    default:
      return status
  }
}

export function colorFromStatus(status: string): ColorUnion {
  switch (status) {
    case 'pending':
      return TagColor.champagne
    case 'uploaded':
      return TagColor.viridian
    case 'ready':
    case 'delivered':
      return TagColor.correct
    case 'failed':
    case 'deactivated':
      return TagColor.radical
    default:
      return TagColor.neutral
  }
}

export function colorFromStatusF0(status: string): 'positive' | 'critical' | 'warning' | 'info' {
  switch (status) {
    case 'pending':
      return 'warning'
    case 'uploaded':
      return 'info'
    case 'ready':
    case 'delivered':
      return 'positive'
    case 'failed':
    case 'deactivated':
      return 'critical'
    default:
      return 'info'
  }
}
